import { Field, FieldLabel } from '@quebon/ui/components/field'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@quebon/ui/components/select'
import type { AcquisitionChannel } from '@/api/lcCrm'
import { ACQUISITION_CHANNEL_LABELS, acquisitionChannelLabel, isAcquisitionChannel } from './acquisitionChannel'

export function AcquisitionChannelField({ id, value, onChange, disabled }: {
  id: string
  value?: AcquisitionChannel
  onChange: (value: AcquisitionChannel | undefined) => void
  disabled?: boolean
}) {
  return (
    <Field data-disabled={disabled}>
      <FieldLabel htmlFor={id}>유입경로</FieldLabel>
      <Select disabled={disabled} value={value ?? 'unset'} onValueChange={(next) => {
        if (next === 'unset') onChange(undefined)
        else if (isAcquisitionChannel(next)) onChange(next)
      }}>
        <SelectTrigger id={id} className="w-full" aria-label="유입경로">
          <SelectValue>{acquisitionChannelLabel(value)}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="unset">미기록</SelectItem>
            {Object.entries(ACQUISITION_CHANNEL_LABELS).map(([channel, label]) => (
              <SelectItem key={channel} value={channel}>{label}</SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </Field>
  )
}
